import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Hook customizado para gerenciar mensagens rotativas durante o loading de insights da iniciativa
 * @param {boolean} isLoading - Se está carregando
 * @param {number} interval - Intervalo entre as mensagens em ms (padrão: 2500ms)
 * @returns {string} - Mensagem atual a ser exibida
 */
export const useInitiativeInsightsMessages = (isLoading, interval = 2500) => {
  const { t } = useTranslation();
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  // Array com as chaves das mensagens específicas para insights de iniciativa
  const messageKeys = [
    "ai_loading.initiative_insights.reading_onepages",
    "ai_loading.initiative_insights.analyzing_patterns",
    "ai_loading.initiative_insights.reviewing_progress",
    "ai_loading.initiative_insights.identifying_risks",
    "ai_loading.initiative_insights.summarizing_insights",
    "ai_loading.initiative_insights.generating_recommendations",
  ];

  useEffect(() => {
    if (!isLoading) {
      setCurrentMessageIndex(0);
      return;
    }

    const intervalId = setInterval(() => {
      setCurrentMessageIndex(
        (prevIndex) => (prevIndex + 1) % messageKeys.length,
      );
    }, interval);

    return () => clearInterval(intervalId);
  }, [isLoading, interval, messageKeys.length]);

  if (!isLoading) {
    return "";
  }

  return t(messageKeys[currentMessageIndex]);
};
